import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addEmail from "../email/components/add.vue";
import { gmRechargeGameAll, recharge_game_all_currency, userDetail, userEmail, banedUserList, banUser, userInfoOperationProp, paySupplementList, userBanLog, gmDagDesc, gmRechargeGame, gmRechargeGame_currency, gmResourceDescList, userInfoAll } from "@/api/gmtool/packageCode";
import { SzesourceDescList, bagRetainDesc } from "@/api/gmToolNew/gmToolNew";
import pickerOption from "@/mixins/module/pickerOption";
import addEmperor from "../emperor/components/add.vue";
import { serchSelect, tabulation, gmTool } from "@/mixins/index";
import viewArticles from "../email/components/viewArticles.vue";
import recoveryviewArticles from "../recovery/components/viewArticles.vue";
import contentView from "../email/components/contentView.vue";
import richTextDetails from "../announcement/components/richTextDetails.vue";
import { Loading } from "element-ui";
import addExport from "./components/addExport.vue";
import watchCodeDetails from "./components/watchCodeDetails.vue";
export default {
  name: "playerDetails",
  mixins: [gmTool, pickerOption, serchSelect, tabulation],
  components: {
    addEmperor: addEmperor,
    addEmail: addEmail,
    viewArticles: viewArticles,
    richTextDetails: richTextDetails,
    contentView: contentView,
    recoveryviewArticles: recoveryviewArticles,
    addExport: addExport,
    watchCodeDetails: watchCodeDetails
  },
  data: function data() {
    return {
      reqLoadingOne: false,
      reqLoadingTow: false,
      exportLoading: false,
      date: [],
      radio: 2,
      dialog: false,
      total: 0,
      // 主列表查询参数
      searchData: {
        user_id: "",
        server_id: "",
        role_id: "",
        is_prod: "",
        role_name: "",
        sdk_user_id: ''
      },
      kindList: [{
        label: "output",
        value: "output"
      }, {
        label: "cost",
        value: "cost"
      }, {
        label: "retain",
        value: "retain"
      }],
      tabbleData: [{}],
      currentPage: 1,
      searchList: [],
      featureList: [{
        title: this.$t('backpack'),
        id: "1"
      }, {
        title: this.$t('items'),
        id: "2"
      }, {
        title: this.$t('orders'),
        id: "3"
      }, {
        title: this.$t('mailbox'),
        id: "4"
      }, {
        title: this.$t('operations'),
        id: "5"
      }, {
        title: this.$t('playerBackpackDetails'),
        id: "6"
      }],
      controlsSort: [{
        title: this.$t('replenishmentLog'),
        index: 0,
        reqFn: paySupplementList,
        searchData: {
          page_size: 10
        },
        list: [],
        page: 1,
        total: 0
      }, {
        title: this.$t('banLog'),
        index: 1,
        reqFn: userBanLog,
        searchData: {
          op_kind: 1
        },
        list: [],
        total: 0
      }, {
        title: this.$t('muteLog'),
        index: 2,
        reqFn: userBanLog,
        searchData: {
          op_kind: 2
        },
        list: [],
        page: 1,
        total: 0
      }, {
        title: this.$t('itemRecycleLog'),
        index: 3,
        reqFn: userInfoOperationProp,
        searchData: {
          page_size: 10
        },
        list: [],
        page: 1,
        page_size: 10,
        total: 0
      }],
      controlsSortIndex: 0,
      checkedCities: "1",
      // 补单数据需要
      supplement: [{
        label: this.$t('supplementReward'),
        value: "supplement_reward"
      }, {
        label: this.$t('supplementOrder'),
        value: "supplement_product"
      }],
      codeLists: [],
      isCode: false,
      detailsData: [],
      // 详情 列表数据查询参数
      userData: {
        starttime: "",
        endtime: "",
        user_id: "",
        server_id: "",
        role_id: ""
      },
      propertySearchData: {
        action: "",
        resource_id: "",
        kind: "",
        page_size: 10,
        page: 1
      },
      property: [],
      propertyTotal: 0,
      orderData: [],
      orderSearchData: {
        page: 1,
        page_size: 10,
        currency_info: "",
        kind: 1
      },
      orderTotal: 0,
      emailList: [],
      emperorType: 1,
      emperorData: {},
      queryData: {},
      userInfoAllData: {},
      isderive: false,
      propertyCurrentPage1: 1,
      propertyPageSize1: 10,
      tablePropertyTableList: [],
      bgCurrentPage: 1,
      bgPageSize: 10,
      bagRetainList: [],
      bgTableCopyTableList: [],
      exportdataDealoading: false
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getsearchDate();

              _this.searchData.is_prod = _this.severlist[0].value;

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  activated: function activated() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.queryData = _this2.$route.params;

              if (_this2.queryData.pkg) {
                _this2.searchData.is_prod = "PROD";
                _this2.searchData.server_id = parseInt(_this2.queryData.server_id);
                _this2.searchData.role_id = _this2.queryData.server_id + _this2.queryData.user_id;
              }

              if (_this2.queryData.role_id) {
                _this2.searchData.is_prod = _this2.queryData.is_prod;
                _this2.searchData.role_id = _this2.queryData.role_id;
              }

              _context2.next = 5;
              return _this2.getserverList();

            case 5:
              if (_this2.queryData.pkg || _this2.queryData.role_id) {
                _this2.searchClick();
              }

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.date[0] = date;
      this.date[1] = date;
    },
    typeChange: function typeChange(e) {
      this.searchData.role_name = "";
      this.searchData.role_id = "";
    },
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    Renewal: function Renewal() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.getsearchDate();

                _context3.next = 3;
                return _this3.getserverList();

              case 3:
                _this3.detailsData = [];
                _this3.searchList = [];
                _this3.total = 0;
                _this3.searchData = _objectSpread(_objectSpread({}, _this3.searchData), {}, {
                  user_id: "",
                  server_id: "",
                  role_id: "",
                  role_name: "",
                  page: 1,
                  is_prod: _this3.searchData.is_prod
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    propertyhandleCurrentChange: function propertyhandleCurrentChange(val) {
      this.propertySearchData.page = val;
      this.getpropertyList();
    },
    propertyhandleCurrentChangeSizeChange: function propertyhandleCurrentChangeSizeChange(e) {
      this.propertySearchData.page_size = e;
      this.propertySearchData.page = 1;
      this.getpropertyList();
    },
    orderhandleCurrentChange: function orderhandleCurrentChange(val) {
      this.orderSearchData.page = val;
      this.getOrderList();
    },
    orderhandleCurrentChangeSizeChange: function orderhandleCurrentChangeSizeChange(e) {
      this.orderSearchData.page_size = e;
      this.orderSearchData.page = 1;
      this.getOrderList();
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(e) {
      // 去除公共游戏参数
      this.searchData.pkg = "";
      this.searchData.ad_channel = "";
      this.searchData.ad_placement = "";
      this.userData.starttime = this.date[0];
      this.userData.endtime = this.date[1];
      this.propertySearchData.page = 1;
      this.orderSearchData.page = 1;
      this.userData.user_id = this.detailsData[0].user_id;
      this.userData.role_id = this.detailsData[0].role_id;
      this.userData.server_id = this.detailsData[0].server_id;

      if (e == 1) {
        this.getBackpackDetails();
      } else if (e == 2) {
        this.getpropertyList();
      } else if (e == 3) {
        this.getOrderList();
      } else if (e == 4) {
        this.getuserEmail();
      } else if (e == 5) {
        this.operationLogChange(this.controlsSortIndex);
      } else if (e == 6) {
        this.getbagRetainDescFn();
      }
    },
    handleCurrentChange: function handleCurrentChange(val, index) {
      this.controlsSort[index].page = val;
      this.operationLogChange(index);
    },
    handleCurrentChangeSizeChange: function handleCurrentChangeSizeChange(e, index) {
      this.controlsSort[index].searchData.page_size = e;
      this.controlsSort[index].page = 1;
      this.operationLogChange(index);
    },
    operationLogChange: function operationLogChange(e) {
      var _this4 = this;

      this.controlsSort[e].list = [];
      this.$nextTick(function () {
        _this4.reqLoadingTow = true;

        _this4.controlsSort[e].reqFn(_objectSpread(_objectSpread(_objectSpread({
          is_prod: _this4.searchData.is_prod
        }, _this4.userData), _this4.controlsSort[e].searchData), {}, {
          page: _this4.controlsSort[e].page
        })).then(function (res) {
          if (res.status == 200) {
            _this4.controlsSort[e].list = res.data.result || res.data.supplementLog || res.data.propLog || res.data.data || res.data || [];
            _this4.controlsSort[e].total = res.data.total || 0;

            _this4.$nextTick(function () {
              _this4.$refs.container.scrollBy(0, 1000000);
            });
          }
        }).finally(function () {
          _this4.reqLoadingTow = false;
        });
      });
    },
    viewCode: function viewCode(data) {
      this.codeLists = JSON.parse(data);
      this.isCode = true;
    },
    viewDetail: function viewDetail(row) {
      var _this5 = this;

      this.detailsData = [row];
      this.handleCheckedCitiesChange(this.checkedCities);
      this.$nextTick(function () {
        _this5.$refs.container.scrollBy(0, 1000000);
      });
    },
    exuserInfoAll: function exuserInfoAll() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, columns, getFn, getData, isEx, list, i, quy;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this6;
                _this6.loading = Loading.service({
                  lock: true,
                  text: _this6.$t('exporting'),
                  background: "rgba(0, 0, 0, 0.7)"
                });
                columns = [{
                  label: _this6.$t('serverName'),
                  prop: "server_name"
                }, {
                  label: _this6.$t('serverId'),
                  prop: "server_id"
                }, {
                  label: _this6.$t('userId'),
                  prop: "user_id"
                }, {
                  label: _this6.$t('roleName'),
                  prop: "role_name"
                }, {
                  label: _this6.$t('roleId'),
                  prop: "role_id"
                }, {
                  label: _this6.$t('level'),
                  prop: "level"
                }, {
                  label: _this6.$t('vipLevel'),
                  prop: "vip"
                }, {
                  label: _this6.$t('fightingPower'),
                  prop: "fighting"
                }, {
                  label: _this6.$t('alliance'),
                  prop: "league_name"
                }, {
                  label: _this6.$t('thirdPartyLoginType'),
                  prop: "account_type"
                }, {
                  label: _this6.$t('rechargeTotalAmount'),
                  prop: "recharge_amount"
                }, {
                  label: _this6.$t('realTimeRechargeAmount'),
                  prop: "real_time_amount"
                }, {
                  label: _this6.$t('coinCount'),
                  prop: "remain_coin"
                }, {
                  label: _this6.$t('gemCount'),
                  prop: "remain_diamond"
                }, {
                  label: _this6.$t('associatedAccount'),
                  prop: "relevancy_role_name"
                }, {
                  label: _this6.$t('channel'),
                  prop: "channel"
                }, {
                  label: _this6.$t('recentLoginRegion'),
                  prop: "last_login_country"
                }, {
                  label: _this6.$t('recentLoginTime'),
                  prop: "last_login_time"
                }, {
                  label: _this6.$t('recentLoginDevice'),
                  prop: "device_id"
                }, {
                  label: _this6.$t('language'),
                  prop: "register_country"
                }, {
                  label: _this6.$t('registerTime'),
                  prop: "register_time"
                }, {
                  label: _this6.$t('country'),
                  prop: "country"
                }, {
                  label: _this6.$t('ip'),
                  prop: "ip"
                }];

                getFn = function getFn() {
                  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                  return new Promise(function (resolve, reject) {
                    userDetail(_objectSpread(_objectSpread(_objectSpread({}, that.searchData), that.defaultData()), {}, {
                      page_size: 50,
                      page: page
                    })).then( /*#__PURE__*/function () {
                      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(res) {
                        return regeneratorRuntime.wrap(function _callee4$(_context4) {
                          while (1) {
                            switch (_context4.prev = _context4.next) {
                              case 0:
                                if (res.status == 200) {
                                  // this.searchList = await this.userListconvert(res.data.data);
                                  resolve(res);
                                }

                              case 1:
                              case "end":
                                return _context4.stop();
                            }
                          }
                        }, _callee4);
                      }));

                      return function (_x) {
                        return _ref.apply(this, arguments);
                      };
                    }());
                  });
                };

                _context5.next = 6;
                return getFn();

              case 6:
                getData = _context5.sent;
                isEx = true;
                list = [];
                i = 0;

              case 10:
                if (!(i < getData.data.last_page)) {
                  _context5.next = 32;
                  break;
                }

                _context5.next = 13;
                return getFn(i + 1);

              case 13:
                quy = _context5.sent;

                if (!(quy.status == 200)) {
                  _context5.next = 25;
                  break;
                }

                _context5.t0 = [];
                _context5.t1 = _toConsumableArray(list);
                _context5.t2 = _toConsumableArray;
                _context5.next = 20;
                return _this6.userListconvert(quy.data.data, false);

              case 20:
                _context5.t3 = _context5.sent;
                _context5.t4 = (0, _context5.t2)(_context5.t3);
                list = _context5.t0.concat.call(_context5.t0, _context5.t1, _context5.t4);
                _context5.next = 29;
                break;

              case 25:
                _this6.loading.close();

                _this6.$message.error(_this6.$t('exportFailedRetry'));

                isEx = false;
                return _context5.abrupt("break", 32);

              case 29:
                i++;
                _context5.next = 10;
                break;

              case 32:
                if (isEx) {
                  _this6.$export.excel({
                    columns: columns,
                    data: list,
                    title: _this6.$route.meta.title
                  });
                }

                _this6.loading.close(); // userInfoAll({ ...this.userInfoAllData, ...this.searchData, ...this.defaultData() }).then(async (res) => {
                //   if (res.status == 200) {
                //     let data = await this.userListconvert(res.data);
                //     this.$export.excel({
                //       columns,
                //       data,
                //       title: this.$route.meta.title,
                //     });
                //   }
                // }).finally(() => {
                //   this.loading.close();
                // });


              case 34:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    userListconvert: function userListconvert(list) {
      var _this7 = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(resolve, reject) {
          var newList, emperor, speaking;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  newList = _toConsumableArray(list);
                  emperor = {};
                  speaking = {};

                  if (!type) {
                    _context6.next = 10;
                    break;
                  }

                  _context6.next = 6;
                  return banedUserList({
                    is_prod: _this7.searchData.is_prod,
                    op_kind: 1
                  });

                case 6:
                  emperor = _context6.sent;
                  _context6.next = 9;
                  return banedUserList({
                    is_prod: _this7.searchData.is_prod,
                    op_kind: 2
                  });

                case 9:
                  speaking = _context6.sent;

                case 10:
                  newList.map(function (i) {
                    i.emperorStatus = emperor.status == 200 ? emperor.data.findIndex(function (e) {
                      return e.accid == i.role_id;
                    }) > -1 ? 1 : 2 : 3;
                    i.speakingStatus = speaking.status == 200 ? speaking.data.findIndex(function (e) {
                      return e.accid == i.role_id;
                    }) > -1 ? 1 : 2 : 3;
                    i.account_type = i.account_type ? i.account_type : _this7.$t('unbound');
                    i.register_time = i.register_time ? i.register_time : "/";
                    i.last_login_time = i.last_login_time ? i.last_login_time : "/";
                    i.recharge_amount = _this7.$utils.conversion(i.recharge_amount).toFixed(2);
                    i.real_time_amount = i.real_time_amount ? _this7.$utils.conversion(i.real_time_amount).toFixed(2) : '/';
                    i.device_id = i.last_logins ? i.last_logins.device_id : "/";
                    i.server_name = _this7.serverLists.findIndex(function (j) {
                      return j.serverID == i.server_id;
                    }) > -1 ? _this7.serverLists.find(function (j) {
                      return j.serverID == i.server_id;
                    }).serverName : i.server_id;
                  });
                  resolve(newList);

                case 12:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    searchClick: function searchClick(e, type) {
      var _this8 = this;

      // if (!this.searchData.user_id) {
      //   this.$message.error('请输入账号ID')
      //   return
      // }
      this.isderive = this.searchData.server_id ? true : false;

      if (this.searchData.server_id) {
        this.userInfoAllData = _objectSpread({}, this.searchData);
      }

      if (type) {
        this.detailsData = [];
      }

      this.searchData.page = e;
      this.reqLoadingOne = true;
      userDetail(_objectSpread(_objectSpread({}, this.searchData), this.defaultData())).then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(res) {
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!(res.status == 200)) {
                    _context7.next = 6;
                    break;
                  }

                  _context7.next = 3;
                  return _this8.userListconvert(res.data.data);

                case 3:
                  _this8.searchList = _context7.sent;
                  _this8.total = res.data.total;

                  _this8.$nextTick(function () {
                    _this8.$refs.container.scrollBy(0, 1);
                  });

                case 6:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }()).finally(function () {
        _this8.reqLoadingOne = false;
      });
    },
    searchClickSizeChange: function searchClickSizeChange(e) {
      this.searchData.page_size = e;
      this.searchClick(1, true);
    },
    emperor: function emperor(row, type) {
      this.emperorType = type;
      this.emperorData = row;
      this.$refs.addEmperor.open(row, type);
    },
    emperorChange: function emperorChange() {
      var _this9 = this;

      var index = this.searchList.findIndex(function (i) {
        return i.id == _this9.emperorData.id;
      });
      this.emperorType == 1 ? this.searchList[index].emperorStatus = 1 : this.searchList[index].speakingStatus = 1;
    },
    unseal: function unseal(data, type) {
      var _this10 = this;

      this.$prompt(this.$t('pleaseInputReason'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(function (_ref4) {
        var value = _ref4.value;
        var d = {
          op_kind: type,
          op_type: 0,
          uids: [{
            uids: parseInt(data.role_id)
          }],
          reason: value || "1",
          is_prod: _this10.searchData.is_prod
        };
        banUser(d).then(function (res) {
          if (res.status == 200) {
            _this10.$message({
              message: _this10.$t('unbanSuccess'),
              type: "success"
            });

            var index = _this10.searchList.findIndex(function (i) {
              return i.id == data.id;
            });

            type == 1 ? _this10.searchList[index].emperorStatus = 2 : _this10.searchList[index].speakingStatus = 2; // this.searchClick()
          }
        });
      });
    },
    exportAll: function exportAll() {
      var _this11 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(resolve, reject) {
          var queue, query;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  queue = [];
                  _context8.next = 3;
                  return gmResourceDescList(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
                    is_prod: _this11.searchData.is_prod
                  }, _this11.searchData), _this11.propertySearchData), _this11.userData), {}, {
                    page_size: -1,
                    page: 1
                  }));

                case 3:
                  query = _context8.sent;

                  if (query.status == 200) {
                    queue = query.data;
                  } else {
                    reject();
                  }

                  resolve(queue);

                case 6:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x5, _x6) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    // 道具导出 
    exportproperty: function exportproperty() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var exportData, columns;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this12.exportdataDealoading = true; // let exportData = JSON.parse(JSON.stringify(this.tablePropertyTableList));

                _context9.next = 3;
                return _this12.exportAll();

              case 3:
                exportData = _context9.sent;
                exportData.forEach(function (item) {
                  var _loop = function _loop(k) {
                    item[k] = "";
                    item.resource[k].forEach(function (a, index) {
                      item[k] += "".concat(a.item_name, ":").concat(a.item_num).concat(index != item.resource[k].length - 1 ? "," : "");
                    });
                  };

                  for (var k in item.resource) {
                    _loop(k);
                  }
                });
                columns = [{
                  label: _this12.$t('userId'),
                  prop: 'user_id_str'
                }, {
                  label: _this12.$t('roleId'),
                  prop: 'role_id'
                }, {
                  label: _this12.$t('deviceId'),
                  prop: 'device_id_str'
                }, {
                  label: 'ext',
                  prop: 'ext'
                }, {
                  label: _this12.$t('costLabel'),
                  prop: 'cost'
                }, {
                  label: _this12.$t('resourceOutputLabel'),
                  prop: 'output'
                }, {
                  label: _this12.$t('retention'),
                  prop: 'retain'
                }, {
                  label: _this12.$t('operation'),
                  prop: 'action'
                }, {
                  label: _this12.$t('operationName'),
                  prop: 'action_name'
                }, {
                  label: _this12.$t('time'),
                  prop: 'time'
                }];

                _this12.$export.excel({
                  columns: columns,
                  data: exportData,
                  title: _this12.$t('items')
                });

                _this12.exportdataDealoading = false;

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    // 背包列表
    getBackpackDetails: function getBackpackDetails() {
      var _this13 = this;

      this.reqLoadingTow = true;
      gmDagDesc(_objectSpread(_objectSpread({
        is_prod: this.searchData.is_prod
      }, this.searchData), this.userData)).then(function (res) {
        if (res.status == 200) {
          var list = ["game", "platform", "channel", "pkg", "ad_channel", "ad_placement"];
          _this13.tableData = res.data.length ? _this13.$utils.dataConversion(res.data, list) : [];
          _this13.currentPage = 1;
          _this13.tableCopyTableList = JSON.parse(JSON.stringify(_this13.tableData));
          _this13.tableData = _this13.currentChangePage(_this13.pageSize, _this13.currentPage);
        }
      }).finally(function () {
        _this13.reqLoadingTow = false;
      });
    },
    // 道具列表
    getpropertyList: function getpropertyList(e) {
      var _this14 = this;

      this.propertySearchData.page = e;
      this.reqLoadingTow = true;
      gmResourceDescList(_objectSpread(_objectSpread(_objectSpread({
        is_prod: this.searchData.is_prod
      }, this.searchData), this.propertySearchData), this.userData)).then(function (res) {
        if (res.status == 200) {
          console.log("res.data.data===", res.data.data);
          res.data.data && res.data.data.map(function (item) {
            // item.timestamp = this.$times.timestampToTime(item.timestamp);
            item.user_id = _this14.userData.user_id;
            item.role_id = _this14.userData.role_id;
          });
          _this14.property = res.data.data;
          _this14.propertyTotal = res.data.total; // let newData = res.data
          // this.propertyCurrentPage1 = 1;
          // this.tablePropertyTableList = JSON.parse(JSON.stringify(newData));
          // this.property = this.propertyCurrentPage(this.propertyPageSize1, this.propertyCurrentPage1);

          _this14.$nextTick(function () {
            _this14.$refs.container.scrollBy(0, 1000000);
          });
        }
      }).finally(function () {
        _this14.reqLoadingTow = false;
      });
    },
    propertyHandleSizeChange: function propertyHandleSizeChange(e) {
      this.propertySearchData.page_size = e;
      this.getpropertyList(1);
    },
    // 订单列表
    getOrderList: function getOrderList() {
      var _this15 = this;

      // if(this.searchCurrency.length && !this.orderSearchData.currency_info){
      //   this.$message.error('请选择货币类型')
      //   return
      // }
      this.reqLoadingTow = true;
      var reqFn = this.searchCurrency.length ? gmRechargeGame_currency : gmRechargeGame;
      reqFn(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        is_prod: this.searchData.is_prod
      }, this.searchData), this.userData), this.orderSearchData), this.defaultData("orderSearchData"))).then(function (res) {
        if (res.status == 200) {
          // res.data.data.map((item) => {
          //   item.timestamp = this.$times.timestampToTime(item.timestamp);
          // });
          var list = ["game", "platform", "channel", "pkg", "ad_channel", "ad_placement"];
          _this15.orderData = res.data.data.length ? _this15.$utils.dataConversion(res.data.data, list) : [];
          _this15.orderTotal = res.data.total;

          _this15.$nextTick(function () {
            _this15.$refs.container.scrollBy(0, 1000000);
          });
        }
      }).finally(function () {
        _this15.reqLoadingTow = false;
      });
    },
    exportdata: function exportdata() {
      var _this16 = this;

      this.exportLoading = true;
      var reqFn = this.orderSearchData.currency_info ? recharge_game_all_currency : gmRechargeGameAll;
      reqFn(_objectSpread(_objectSpread(_objectSpread({
        is_prod: this.searchData.is_prod
      }, this.searchData), this.userData), this.orderSearchData)).then(function (res) {
        if (res.status == 200) {
          var columns = [{
            label: _this16.$t('adChannel'),
            prop: "ad_channel_reveal"
          }, {
            label: _this16.$t('adPlacement'),
            prop: "ad_placement_reveal"
          }, {
            label: _this16.$t('country'),
            prop: "country"
          }, {
            label: _this16.$t('rdOrderId'),
            prop: "order_id"
          }, {
            label: _this16.$t('channelOrderId'),
            prop: "pay_channel_order_id"
          }, {
            label: _this16.$t('userId'),
            prop: "user_id"
          }, {
            label: _this16.$t('roleId'),
            prop: "role_id"
          }, {
            label: _this16.$t('deviceId'),
            prop: "device_id"
          }, {
            label: _this16.$t('payAmount'),
            prop: "amount"
          }, {
            label: _this16.$t('rechargeProductId'),
            prop: "product_id"
          }, {
            label: _this16.$t('rechargeProductName'),
            prop: "product_name"
          }, {
            label: _this16.$t('rechargeTime'),
            prop: "timestamp"
          }, {
            label: _this16.$t('ip'),
            prop: "ip"
          }];
          var list = ["game", "platform", "channel", "pkg", "ad_channel", "ad_placement"];
          var data = res.data.length ? _this16.$utils.dataConversion(res.data, list) : [];
          data.map(function (item) {
            item.amount = _this16.$utils.conversion(item.amount).toFixed(2); // item.timestamp = this.$times.timestampToTime(item.timestamp);
          });

          _this16.$export.excel({
            columns: columns,
            data: data,
            title: _this16.$route.meta.title
          });
        }
      }).finally(function () {
        _this16.exportLoading = false;
      });
    },
    // 邮箱列表
    getuserEmail: function getuserEmail() {
      var _this17 = this;

      this.reqLoadingTow = true;
      userEmail(_objectSpread(_objectSpread({
        is_prod: this.searchData.is_prod
      }, this.propertySearchData), this.userData)).then(function (res) {
        if (res.status == 200) {
          _this17.emailList = res.data;
        }
      }).finally(function () {
        _this17.reqLoadingTow = false;
      });
    },
    //背包物品存量
    getbagRetainDescFn: function getbagRetainDescFn() {
      var _this18 = this;

      this.reqLoadingTow = true;
      bagRetainDesc(_objectSpread(_objectSpread({
        is_prod: this.searchData.is_prod
      }, this.searchData), this.userData)).then(function (res) {
        if (res.status == 200) {
          var tableNewdata = res.data.data;
          _this18.bgTableCopyTableList = JSON.parse(JSON.stringify(tableNewdata));
          _this18.bagRetainList = _this18.bgCurrentChangePage(_this18.bgPageSize, _this18.bgCurrentPage);
        }
      }).finally(function () {
        _this18.reqLoadingTow = false;
      });
    },
    // 页数改变事件
    bgHandleSizeChange: function bgHandleSizeChange(pageSize) {
      this.bgCurrentPage = 1;
      this.bgPageSize = pageSize;
      this.bagRetainList = this.bgCurrentChangePage(pageSize, this.currentPage);
    },
    // 页码改变切换
    bgHandleCurrentChange: function bgHandleCurrentChange(currentPage) {
      this.bgCurrentPage = currentPage;
      this.bagRetainList = this.bgCurrentChangePage(this.bgPageSize, currentPage);
    },
    // 分页方法
    bgCurrentChangePage: function bgCurrentChangePage(size, current) {
      var tablePush = [];
      this.bgTableCopyTableList.forEach(function (item, index) {
        if (size * (current - 1) <= index && index <= size * current - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    },
    // 背包物品分页
    // 页数改变事件
    handleSizeChange: function handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.tableData = this.currentChangePage(pageSize, this.currentPage);
    },
    // 页码改变切换
    handleCurrentChange1: function handleCurrentChange1(currentPage) {
      var _this19 = this;

      this.currentPage = currentPage;
      this.tableData = this.currentChangePage(this.pageSize, currentPage);
      this.$nextTick(function () {
        _this19.$refs.container.scrollBy(0, 1000000);
      });
    },
    backSizeChange: function backSizeChange(e) {
      this.pageSize = e;
      this.handleCurrentChange1(1);
    },
    // 分页方法
    currentChangePage: function currentChangePage(size, current) {
      var tablePush = [];
      this.tableCopyTableList.forEach(function (item, index) {
        if (size * (current - 1) <= index && index <= size * current - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    }
  }
};